import { PageNotFoundPlaceholder } from 'app/common/components/placeholder/PageNotFoundPlaceholder';
import IS_IFRAME from 'app/common/data/iframe';
import { useHideIntercom } from 'app/common/hooks/useHideIntercom';
import { DeviceType, IS_BELOW_TABLET, useDeviceType } from 'app/hooks';

import { NotFoundPageWrapper } from './NotFoundPage.styled';

export const NotFoundPage = () => {
    const { device, isBelowProvidedDevices } = useDeviceType(IS_BELOW_TABLET);
    const displayButton = !IS_IFRAME && isBelowProvidedDevices;
    const isMobile = device === DeviceType.Mobile || device === DeviceType.MobileApp;

    useHideIntercom(isMobile);

    return (
        <NotFoundPageWrapper>
            <PageNotFoundPlaceholder withButton={displayButton} />
        </NotFoundPageWrapper>
    );
};
